/**
 * Constants for Stripe-related URLs
 */

export const STRIPE_BILLING_URL =
  'https://billing.stripe.com/p/login/9AQcQ52xifxKdUs7ss';
